import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'petasti';
const args = {};

export class Petasti extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
